import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-first-installation-congratulations-dialog",
  templateUrl: "./first-installation-congratulations-dialog.component.html",
  styleUrls: ["./first-installation-congratulations-dialog.component.scss"],
  standalone: false,
})
export class FirstInstallationCongratulationsDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<FirstInstallationCongratulationsDialogComponent>,
    private router: Router,
  ) {}

  goToEmployees(): void {
    this.dialogRef.close();
    void this.router.navigate(["/employees"]);
  }

  close(): void {
    this.dialogRef.close();
  }
}
